import { OptionsObject, SnackbarKey } from 'notistack';

export type NotificationKey = SnackbarKey;
export interface IPopupNotification {
  severity?: 'success' | 'info' | 'warning' | 'error' | 'neutral';
  message: string;
  options?: OptionsObject;
}

export interface IPopupNotificationData {
  dismissed?: boolean;
  key: NotificationKey;
  notification: IPopupNotification;
}

export type IPopupNotificationsState = IPopupNotificationData[];

export const POPUP_NOTIFICATION_INITIAL_STATE: IPopupNotificationsState = [];
